/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Linter } from "eslint-linter-browserify";
const linter = new Linter();

const Lint = ({ css, onComplete }) => {
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        if (css) {
            const linterMessages = linter.verify(css, {
                rules: {
                    semi: 2,
                    eqeqeq: 2,
                    quotes: ["error", "double"], //need to check
                    "no-extra-semi": 2,
                    "array-bracket-newline": 2,
                    "arrow-spacing": 2, // need to check
                    "func-call-spacing": ["error", "never"],//not working
                    "linebreak-style": "unix", //need to check
                    "space-before-blocks": ["error", "never"],
                    "object-curly-spacing": ["error", "never"],
                    "array-bracket-spacing": ["error", "never"],
                    "space-in-parens": ["error", "never"],
                    "indent": ["error", 2],
                    "no-multiple-empty-lines": ["error", { "max": 0, "maxEOF": 0, "maxBOF": 0 }],
                    "semi-spacing": [2, { "before": false, "after": true }],
                    "no-multi-spaces": 2
                }
            }, { filename: "foo.js" });

            setMessages(linterMessages);
            if (linterMessages.length === 0) {
                const fixedLint = linter.verifyAndFix(css, {
                    rules: {
                        semi: 2,
                        eqeqeq: 2,
                        "no-extra-semi": 2,
                        "array-bracket-newline": 2,
                        "arrow-spacing": 2,
                        "func-call-spacing": 2,
                        "linebreak-style": "unix",
                        "semi-spacing": [2, { "before": false, "after": true }],
                        "no-multi-spaces": 2
                    }
                });
                const expectedOutput = "function add(a,b){\nreturn a+b;\n}"
                if (fixedLint.output.replaceAll(" ", "") === expectedOutput.replaceAll(" ", "")) {
                    onComplete();
                }
                else {
                    setMessages([{ message: "Do not alter the code" }]);
                }
            }
        }
    }, [css])

    console.log(messages);

    return (
        <div id="code-container">
            <pre style={{ "white-space": "pre-wrap" }}>
                {messages.reduce((finalMessages, currentMessage) => {
                    return finalMessages + `${currentMessage.line ? "\nLine" + currentMessage.line + ":" : ""} ${currentMessage.message}`
                }, '')}
            </pre>
        </div>
    )
}

export default Lint;